let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("14qp2")]).then(() => parcelRequire('fr6n2'));